import Icon from './icon';
export default {
  Icon,
  title: 'Ellipse',
  hotkey: 'e'
};